<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-proceeds page-operative-data-analysis-proceeds-edit">
    <div class="container">
      <PageTitle>Modifica ricavo</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Ricavo da modificare non trovato</div>
      <FormRicavo v-else-if="company && userCanEdit" :ricavo.sync="ricavo" edit @saved="saveRicavo" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage.js';
import { addForecastToRouteQueryString } from '@/helpers/routes.js';

export default {
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle.vue'),
    FormRicavo: () => import('@/views/components/Operative/Form/FormRicavo.vue'),
  },
  data () {
    return {
      ricavo: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveRicavo (ricavo) {
      this.$api.updateRicavo(this.company.id, ricavo.id, ricavo)
        .then(() => {
          this.$router.push(addForecastToRouteQueryString({ name: 'operative-company.data-analysis.proceeds' }, this.$route));
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getRicavo(this.company.id, this.$route.params.proceedId)
          .then(res => {
            this.ricavo = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
